export const DEFAULT_APP_URL = 'https://app.soraban.com' as const;
export const DEV_APP_URL = 'http://localhost:8080' as const;
